// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"711b1545","628":"9b45ca3d"}[chunkId] + ".chunk.css";
};